import React from "react";
import Image from "next/image";
import { ANIMALIA_TOKEN_VALUES } from "../tokens";

/** Stable, locally stored Unsplash portraits; randomizing tokens keeps the team. */
const AniAvatarGroup = ({ people }: { people: string[] }) => (
  <div className="ani-avatars" data-token="Ani Avatar Group" data-pad="xs">
    {people.map((person, index) => (
      <span data-token="Ani Avatar/Photo" key={person} className="ani-avatar" title={person} style={{ zIndex: people.length - index }}>
        <Image src={`/images/animalia/playground/avatar-${(index % 4) + 1}.jpg`}
          alt={person} width={ANIMALIA_TOKEN_VALUES.avatarSize} height={ANIMALIA_TOKEN_VALUES.avatarSize} />
      </span>
    ))}
  </div>
);

export default AniAvatarGroup;
